import { SimpleNewsOptions, SimpleNewsQuery, SimpleNewsQueryAndOptions } from '@benzinga/internal-news-manager';

export const formatToSimpleNewsQueryParams = (
  queryParams: SimpleNewsQueryAndOptions,
): { options: SimpleNewsOptions; query: SimpleNewsQuery } => {
  if (!queryParams) return { options: {}, query: {} };
  const {
    after,
    allOriginalArticles,
    author,
    before,
    channelAndTagQueryOperator,
    channels,
    displayOutput,
    excludeAutomated,
    excludeContentTypes,
    excludeContributed,
    excludeSponsored,
    headlines,
    last,
    limit,
    offset,
    primaryChannel,
    search,
    sortOrderCreated,
    tags,
    tickers,
    title,
    type,
    userId,
  } = queryParams;

  const typeParam: string[] | undefined = typeof type === 'string' ? type.split(',') : type || undefined;

  const options: SimpleNewsOptions = {
    after,
    allOriginalArticles,
    before,
    displayOutput,
    excludeAutomated,
    excludeContentTypes,
    excludeContributed,
    excludeSponsored,
    headlines: (headlines as string) === 'true' ? true : (headlines as string) === 'false' ? false : headlines,
    last,
    limit: limit ? Number(limit) : undefined,
    offset: offset ? Number(offset) : undefined,
    sortOrderCreated,
    type: typeParam,
  };

  const arrayOfTickers: string[] = typeof tickers === 'string' ? tickers.split(',') : tickers || [];
  const formattedSymbols = tickers ? formatSymbols(arrayOfTickers) : undefined;

  const query: SimpleNewsQuery = {
    author,
    channelAndTagQueryOperator,
    channels,
    primaryChannel,
    search,
    tags,
    tickers: formattedSymbols,
    title,
    userId,
  };

  const result = {
    options,
    query,
  };

  return result;
};

export const formatSymbols = (symbols: string | string[]): string | string[] => {
  let result: string | string[] = [];
  if (typeof symbols === 'string') {
    result = symbols.replace('/', '-');
  } else if (Array.isArray(symbols)) {
    result = symbols.map(symbol => symbol.replace('/', '-'));
  }
  return result;
};
